import { render, staticRenderFns } from "./SlideNews.vue?vue&type=template&id=5adf001f&scoped=true"
import script from "./SlideNews.vue?vue&type=script&lang=js"
export * from "./SlideNews.vue?vue&type=script&lang=js"
import style0 from "./SlideNews.vue?vue&type=style&index=0&id=5adf001f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf001f",
  null
  
)

export default component.exports